
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#6FCF97","d":"M10 22.55a6.55 6.55 0 1113.1 0 6.55 6.55 0 01-13.1 0zM27.31 20a4 4 0 014-4H66a4 4 0 014 4v5.1a4 4 0 01-4 4H31.31a4 4 0 01-4-4V20z"}}),_c('path',{attrs:{"fill":"#219653","d":"M27.31 37.45a4 4 0 014-4H66a4 4 0 014 4v5.1a4 4 0 01-4 4H31.31a4 4 0 01-4-4v-5.1z"}}),_c('path',{attrs:{"fill":"#6FCF97","d":"M27.31 54.9a4 4 0 014-4H66a4 4 0 014 4V60a4 4 0 01-4 4H31.31a4 4 0 01-4-4v-5.1z"}}),_c('path',{attrs:{"fill":"#219653","d":"M10 40c0-3.6 2.92-6.55 6.53-6.55a6.54 6.54 0 010 13.1A6.54 6.54 0 0110 40z"}}),_c('path',{attrs:{"fill":"#6FCF97","d":"M10 57.45c0-3.6 2.92-6.54 6.53-6.54a6.54 6.54 0 010 13.09A6.54 6.54 0 0110 57.45z"}})])
          )
        }
      }
    